import { useLocation, useNavigate } from "react-router-dom";
import { LOGOS, NAV } from "../../lib/ablemp-data";

export const Footer = () => {
  const year = new Date().getFullYear();
  const navigate = useNavigate();
  const location = useLocation();
  const isHome = location.pathname === "/";

  const goTo = (item) => {
    if (item.route) {
      navigate(item.route);
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }
    if (!isHome) {
      navigate("/", { state: { scrollTo: item.id } });
      return;
    }
    const el = document.getElementById(item.id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#0A0F14] text-white overflow-hidden"
    >
      <div className="absolute inset-0 bg-grain-dark opacity-50 pointer-events-none" />

      {/* Oversized CTA headline */}
      <div className="relative max-w-[1400px] mx-auto px-6 md:px-10 pt-24 md:pt-32 pb-16 border-b border-white/10">
        <div className="text-[11px] uppercase tracking-[0.3em] text-white/55">
          Manifesto · Brasil 2025
        </div>
        <h3
          data-testid="footer-headline"
          className="mt-6 font-serif-display text-[48px] sm:text-[80px] lg:text-[120px] leading-[0.92] tracking-[-0.03em]"
        >
          Liberdade é poder{" "}
          <span className="italic font-light text-[#FEDF00]">
            escolher
          </span>{" "}
          como se paga.
        </h3>
      </div>

      {/* Footer grid */}
      <div className="relative max-w-[1400px] mx-auto px-6 md:px-10 py-16 grid grid-cols-12 gap-10">
        <div className="col-span-12 md:col-span-5">
          <img
            src={LOGOS.white}
            alt="ABLEMP"
            className="h-20 md:h-24 w-auto"
          />
          <p className="mt-6 text-white/65 text-sm leading-relaxed max-w-sm">
            Associação Brasileira de Defesa da Liberdade de Escolha dos Meios de
            Pagamento. Uma iniciativa civil, sem fins lucrativos, pela
            pluralidade dos meios de pagamento no Brasil.
          </p>
        </div>

        <div className="col-span-6 md:col-span-3">
          <div className="text-[10px] uppercase tracking-[0.3em] text-white/45">
            Navegação
          </div>
          <ul className="mt-5 space-y-3">
            {NAV.map((n) => (
              <li key={n.id}>
                <button
                  data-testid={`footer-nav-${n.id}`}
                  onClick={() => goTo(n)}
                  className="text-sm text-white/85 editorial-link"
                >
                  {n.label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div className="col-span-6 md:col-span-4">
          <div className="text-[10px] uppercase tracking-[0.3em] text-white/45">
            Contato
          </div>
          <ul className="mt-5 space-y-3 text-sm">
            <li>
              <a
                data-testid="footer-email-general"
                href="mailto:contato@ablemp.org.br"
                className="text-white/85 editorial-link"
              >
                contato@ablemp.org.br
              </a>
            </li>
            <li className="text-white/65 text-xs leading-relaxed">
              Av. Paulista, 1636, Conj. 4, Pav. 15
              <br />
              Bela Vista · São Paulo — SP
              <br />
              CEP 01.310-200
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="relative border-t border-white/10">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <div className="text-[10px] uppercase tracking-[0.3em] text-white/45">
            © {year} ABLEMP. Todos os direitos reservados.
          </div>
          <div className="flex items-center gap-3">
            <span className="h-1 w-6" style={{ background: "#002776" }} />
            <span className="h-1 w-6" style={{ background: "#009B3A" }} />
            <span className="h-1 w-6" style={{ background: "#FEDF00" }} />
            <span className="text-[10px] uppercase tracking-[0.3em] text-white/55 ml-2">
              Feito no Brasil
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
